<template>
<div class="chapter">
<div class="inner_page">
<p class="front">Then I saw that there was a way to hell, even from the gates of heaven.</p>
<p class="right"><span class="small">JOHN BUNYAN</span>: <em class="italic">The Pilgrim’s Progress</em></p>
<p class="center">O where is tinye Hew?<br/>And where is little Lenne?<br/>And where is bonny Lu?<br/>And Menie of the Glenne?<br/>And where’s the place of rest—<br/>The ever changing hame?<br/>Is it the gowan’s breast,<br/>Or ‘neath the bells of faem?</p>
<p class="center">Ay, lu, lan, dil y’u</p>
<p class="righta"><span class="small">ANON</span>: <em class="italic">The Gloamyne Buchte</em></p>
<p class="center">Wir holen sie ein auf jenen Höh’n<br/>Im Sonnenschein.<br/>Der Tag ist schön auf jenen Höh’n</p>
<p class="righta"><span class="small">FRIEDRICH RÜCKERT</span>:<br/><em class="italic">Kindertotenlieder IV</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Front.vue?52a03aa5